export default {
  text: '#4c352d',
  primary: '#23C1E5',
  secondary: '#EB70AE',
  background: '#f9f9f9',
  backgroundSecondary: '#f4d6b6',
  light: '#FFF',
  dark: '#020303'
}
